module.exports = __webpack_public_path__ + "src/assets/img/bg12.5a59d541.jpg";